module.exports = __webpack_public_path__ + "img/img2.58e343b0.svg";